import { render, staticRenderFns } from "./PositionItem.vue?vue&type=template&id=64172ff7&scoped=true&"
import script from "./PositionItem.vue?vue&type=script&lang=js&"
export * from "./PositionItem.vue?vue&type=script&lang=js&"
import style0 from "./PositionItem.vue?vue&type=style&index=0&id=64172ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64172ff7",
  null
  
)

export default component.exports